import { render, staticRenderFns } from "./LessonsHistory.vue?vue&type=template&id=ddb71a36&scoped=true"
import script from "./LessonsHistory.vue?vue&type=script&lang=js"
export * from "./LessonsHistory.vue?vue&type=script&lang=js"
import style0 from "./LessonsHistory.vue?vue&type=style&index=0&id=ddb71a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb71a36",
  null
  
)

export default component.exports